// cache em memória, escopo global ou de módulo
const memoryCache = {};

/**
 * Faz fetch e armazena em cache usando uma chave.
 * @param {string} key - Chave única para identificar os dados no cache.
 * @param {string} url - Caminho ou endpoint da requisição.
 * @param {object} [options] - Opções para passar ao fetch (opcional).
 * @returns {Promise<any>} Dados retornados da requisição (ou do cache).
 */

function toRootAbsoluteUrl(url) {
  // se já for absoluta, mantém
  if (/^https?:\/\//i.test(url)) return url;
  // se começar com "/", resolve da raiz
  if (url.startsWith("/")) return url;
  // se for relativo simples, força pra raiz
  return "/" + url;
}

export async function fetchWithMemoryCache(key, url, options = {}) {
  if (memoryCache[key]) {
    return memoryCache[key];
  }

  const absUrl = toRootAbsoluteUrl(url);

  const response = await fetch(absUrl, options);
  if (!response.ok) {
    const ct = response.headers.get('content-type') || '';
    const raw = await response.text();
    if (!ct.includes('application/json')) {
      // NÃO CACHEIE isso
      throw new Error(`Esperava JSON em ${absUrl}, recebi ${ct}. Início: ${raw.slice(0,100)}`);
    }
    /*if(response.status === 404) {  
      console.log("voltei aqui"); 
      window.location.href = "/flu";
    }*/

    throw new Error(`Requisição falhou: ${response.status}`);
  }

  const data = await response.json();

  memoryCache[key] = data;

  return data;
}
